import React from "react";
import PageWrapper from "./VisitProgram.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import VisitProgramTable from "../../components/visitProgram/visitProgramTable";

const VisitProgram = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.visit_program"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.visit_program"
          }
        ]}
      />
      <div className="user-tbl">
        <VisitProgramTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.permissionReducer,
    authData: {
      token: state.auth.token,
      isLogin: state.auth.isLogin,
      profileImage: state.auth.profile_image,
      adminRoleId: state.auth.admin_role_id,
      adminRole: state.auth.admin_role,
      full_name: state.auth.first_name + " " + state.auth.last_name,
      service_id: state.auth.service_id
    }
  };
};

export default connect(mapStateToProps, null)(VisitProgram);
